import "./Home.css";
import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import ProductsHome from "./ProductsHome"; 
import ServiceHome from "./ServiceHome";
import Quetions from "./Questions";

function Home() {

  return (
  <>

    <div className="full-screen-blur">
    <div className="welcome-text">
    Welcome to <br />
    <span className="welcome-text-sec">Creora</span> <br />
    <span>Developers</span>
  
  </div>
  <div className="card-head">
  <div className="home-cards-one">
  Immersive Storytelling<br/>
  <span>We turn visions into interactive narratives.</span>
  </div>
  <div className="home-cards-two">
  Product Prototyping in VR<br />
  <span>Bring ideas to life with real-time simulations.</span>
    </div>
    <div className="home-cards-three">
    User-Centric Design<br />
      <span>Crafting intuitive experiences with real-world impact.</span>
    </div>
    </div>
<ProductsHome/>
<ServiceHome/>
<Quetions/>


    </div>
    </>
  );
}

export default Home;
